import React, { useState, useLayoutEffect } from "react";
import Cookies from "universal-cookie";

import AudiencesInput from '../inputs/audiences-input';

import audiences from '../../context/fields/audiencesModal';

import * as styles from './modal.module.scss';

const AudiencesModal = ({ modalAudiencesOpen, setAudiencesModalOpen }) => {
    const cookies = new Cookies();
    const [checked, setChecked] = useState(false);

    useLayoutEffect(() => {
        if (cookies.get("AudienceSet")) {
        setAudiencesModalOpen(false);
        }
        setChecked(true);
    }, []);
    if (!checked) return null;

    return (
        <div className={styles.modal + (modalAudiencesOpen ? ` ` + styles.hidden : '')}>
            <div className={styles.modalAudiences}>
            <section>
                <div className={styles.modalHeader}>
                    <h2 className={styles.audiencesHeader}>
                        Welcome to the Green Upgrade Calculator!
                        <small>Please select your user type:</small>
                    </h2>
                    <button className={styles.modalClose} onClick={e => setAudiencesModalOpen(!modalAudiencesOpen)}>Close</button>
                </div>
                <div className='card-radio audience-radio'>
                    <AudiencesInput
                        input={audiences?.input}
                        setAudiencesModalOpen={setAudiencesModalOpen}
                    />
                </div>
            </section>
            </div>
        </div>
    );
};

export default AudiencesModal